module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Light.7cd52f29.woff";